import { Button } from 'antd'
import { FormattedMessage } from 'react-intl'
import { lang } from './lang'
import { Step } from '.'

type Props = {
  step: Step
  isNetworksAvailable: boolean
  onChangeStep: () => void
  onClose: () => void
}

export default function ActionButton({ step, onChangeStep, onClose, isNetworksAvailable }: Props) {
  if (step === 'coin' && isNetworksAvailable) {
    return (
      <Button size="large" block onClick={onChangeStep} type="primary">
        <FormattedMessage {...lang.selectNetworkButton} />
      </Button>
    )
  }

  if (step === 'network' || (step === 'coin' && !isNetworksAvailable)) {
    return (
      <Button size="large" block onClick={onClose} type="primary">
        <FormattedMessage {...lang.confirmButton} />
      </Button>
    )
  }

  return null
}
